import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Params,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import pickBy from 'lodash.pickby';

const oldCategoryQueryParams = 'f.category.0';
const newCategoryQueryParams = 'f.categories.0';
const oldPromotionQueryParams = 'f.isHasPromotion';
const newPromotionQueryParams = 'f.promotion';
const oldSortParams = /^[s][.]([a-zA-Z]+)/;

@Injectable({
  providedIn: 'root',
})
export class PlpV2Guard implements CanActivate {

  constructor(private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot
  ): Promise<boolean> | Observable<boolean> {

    if (!route.queryParams) {
      return of(true);
    }

    let params: Params | null = null;

    // Replacing f.isHasPromotion with f.promotion
    if (route.queryParams[oldPromotionQueryParams]) {
      params = this.removeKeyFromParams(route.queryParams, oldPromotionQueryParams);
      params = this.addKeyToParams(params, newPromotionQueryParams, true);
    }

    // Replacing f.category with f.categories
    if (route.queryParams[oldCategoryQueryParams]) {
      const category = route.queryParams[oldCategoryQueryParams];
      params = this.removeKeyFromParams(params || route.queryParams, oldCategoryQueryParams);
      params = this.addKeyToParams(params, newCategoryQueryParams, category);
    }

    // Replacing s.[sortKey]=sortValue with orderBy=sortKey&order=sortValue
    const sortParamKey = Object.keys(route.queryParams).find(key => key.match(oldSortParams) != null);
    if(sortParamKey) {
      const matches = sortParamKey.match(oldSortParams);
      const sortValue = route.queryParams[matches[0]];
      const sortKey = matches[1];

      params = this.removeKeyFromParams(params || route.queryParams, sortParamKey);
      params = this.addKeyToParams(params, 'orderBy', sortKey);
      params = this.addKeyToParams(params, 'order', sortValue);
    }

    if (params === null) {
      return of(true);
    }

    const url = state.url.split('?')[0];
    return this.router.navigate([`${url}`], {
      queryParams: params
    });
  }

  private removeKeyFromParams(params: Params, key: string): Params {
    return pickBy(params, (v, attr) => attr !== key);
  }

  private addKeyToParams(params: Params, key: string, value: any): Params {
    return { ...params, [key]: value };
  }
}
